import { CheckOutlined } from '@ant-design/icons';
import { Card, Timeline, Typography } from 'antd';
import moment from 'moment';
import { Trans } from 'react-i18next';

interface RequestJobPostingFinishedTimelineProps {
  createdDate: string;
}

const RequestJobPostingFinishedTimeline = ({
  createdDate,
}: RequestJobPostingFinishedTimelineProps) => {
  return (
    <Timeline.Item dot={<CheckOutlined />}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text>
            <Trans>Requisição finalizada automaticamente</Trans>
          </Typography.Text>
        </Typography.Paragraph>
      </Card>
    </Timeline.Item>
  );
};

export default RequestJobPostingFinishedTimeline;
